import React, { Suspense, lazy } from 'react'
import { shallowEqual, useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom'
import { RootState } from '../../setup';
import { FallbackView } from '../../_metronic/partials'


export function PrivateRoutes() {
  const rights: any = useSelector<RootState>(({ auth }: any) => auth.rights, shallowEqual);
  const instance: any = useSelector<RootState>(({ search }: any) => search.companyId, shallowEqual);
  const CustomerPageWrapper = lazy(() => import('../pages/customer/CustomerPageWrapper'))
  const CompanyUserPageWrapper = lazy(() => import('../pages/user/UserPageWrapper'))
  const RequestTablePageWrapper = lazy(() => import('../pages/requestTable/RequestTablePageWrapper'))
  const CustomRequestTablePageWrapper = lazy(() => import('../pages/customRequestTable/RequestTablePageWrapper'))
  const LicencePageWrapper = lazy(() => import('../pages/licences/LicencePageWrapper'))
  const ExecuteSqlPageWrapper = lazy(() => import('../pages/executeSql/ExecuteSqlPageWrapper'))
  const DeviceConfigWrapper = lazy(() => import('../pages/deviceConfig/DeviceConfigWrapper'))
  const MailsPageWrapper = lazy(() => import('../pages/mails/MailsPageWrapper'))
  const xmlTablePageWrapper = lazy(() => import('../pages/xmlTable/XmlTablePageWrapper'))
  const UpdateSqlPageWrapper = lazy(() => import('../pages/updateSqlTable/UpdateSqlPageWrapper'))
  const MailsListPageWrapper = lazy(() => import('../pages/mailsList/MailsListPageWrapper'))
  const ErpPageWrapper = lazy(() => import('../pages/erp/ErpPageWrapper'))
  const PartnersPageWrapper = lazy(() => import('../pages/partner/PartnersPageWrapper'))
  const ServerConfigPage = lazy(() => import('../pages/serverConfig/ServerConfigPageWrapper'))
  const SystemBackupWapper = lazy(() => import('../pages/systemBackup/SystemBackupPageWrapper'))
  const UpdateTableXMLWapper = lazy(() => import('../pages/updateTableXML/UpdateTableXMLPageWrapper'))
  const JournalsPageWrapper = lazy(() => import('../pages/journals/JournalsPageWrapper'))
  const AppliedScriptPage = lazy(() => import('../pages/appliedScript/appliedScriptPageWrapper'))
  const ErrorLogPageWrapper = lazy(() => import('../pages/errorLog/ErrorLogPageWrapper'))
  const NewCompanyPageWrapper = lazy(() => import('../pages/newCompany/NewCompanyPageWrapper'))
  const ReportsPageWrapper = lazy(() => import('../pages/reports/ReportsPageWrapper'))
  const SystemReportPageWrapper = lazy(() => import('../pages/systemReports/SystemReportPageWrapper'))

  return (
    <Suspense fallback={<FallbackView />}>
      {
        !rights['admin_allsystems'] && !rights['admin_ownagentsystems'] ?
          <Switch>
            <Route exact path='/account/customer/:id' component={CustomerPageWrapper} />
            <Route exact path='/account/license/:id' component={LicencePageWrapper} />
            <Route exact path='/account/user/:id' component={CompanyUserPageWrapper} />
            <Route exact path='/account/system/requesttable/:id' component={RequestTablePageWrapper} />
            <Route exact path='/account/customereporting/:id' component={CustomRequestTablePageWrapper} />
            <Route exact path='/account/system/devicesettings/:id' component={DeviceConfigWrapper} />
            <Route exact path='/account/system/status/:id' component={ExecuteSqlPageWrapper} />
            <Route exact path='/account/system/updatetable/:id' component={UpdateTableXMLWapper} />
            <Route exact path='/maintenance/mails/:id' component={MailsPageWrapper} />
            <Route exact path='/maintenance/tablexml/:id' component={xmlTablePageWrapper} />
            <Route exact path='/maintenance/freemail/:id' component={MailsListPageWrapper} />
            <Route exact path='/maintenance/serverconfig/:id' component={ServerConfigPage} />
            <Route exact path='/maintenance/partners/:id' component={PartnersPageWrapper} />
            <Route exact path='/maintenance/erp/:id' component={ErpPageWrapper} />
            <Route exact path='/maintenance/systembackup/:id' component={SystemBackupWapper} />
            <Route exact path='/maintenance/sqlupdates/:id' component={UpdateSqlPageWrapper} />

            <Redirect from='/auth' to={`/account/customer/${instance}`} />
            <Redirect exact from='/' to={`/account/customer/${instance}`} />
            <Redirect to='error/404' />
          </Switch>
          :
          <Switch>
            <Route path='/account/customer/:id' component={CustomerPageWrapper} />
            <Route path='/account/license/:id' component={LicencePageWrapper} />
            <Route exact path='/account/user/:id' component={CompanyUserPageWrapper} />
            <Route exact path='/account/system/requesttable/:id' component={RequestTablePageWrapper} />
            <Route exact path='/account/customereporting/:id' component={CustomRequestTablePageWrapper} />
            <Route exact path='/account/system/journal/:id' component={JournalsPageWrapper} />
            <Route exact path='/account/system/appliedscripts/:id' component={AppliedScriptPage} />
            <Route exact path='/account/system/errorlogs/:id' component={ErrorLogPageWrapper} />
            <Route exact path='/account/system/devicesettings/:id' component={DeviceConfigWrapper} />
            <Route exact path='/account/system/status/:id' component={ExecuteSqlPageWrapper} />
            <Route exact path='/account/system/updatetable/:id' component={UpdateTableXMLWapper} />
            <Route exact path='/account/system/reports/:id' component={SystemReportPageWrapper} />
            <Route exact path='/maintenance/mails/:id' component={MailsPageWrapper} />
            <Route exact path='/maintenance/tablexml/:id' component={xmlTablePageWrapper} />
            <Route exact path='/maintenance/freemail/:id' component={MailsListPageWrapper} />
            <Route exact path='/maintenance/serverconfig/:id' component={ServerConfigPage} />
            <Route exact path='/maintenance/erp/:id' component={ErpPageWrapper} />
            <Route exact path='/maintenance/partners/:id' component={PartnersPageWrapper} />
            <Route exact path='/maintenance/sqlupdates/:id' component={UpdateSqlPageWrapper} />
            <Route exact path='/maintenance/systembackup/:id' component={SystemBackupWapper} />
            <Route exact path='/maintenance/newcompany/:id' component={NewCompanyPageWrapper} />
            <Route exact path='/maintenance/reports/:id' component={ReportsPageWrapper} />
            <Redirect from='/auth' to='/searchFilter' />
            <Redirect exact from='/' to='/searchFilter' />
            <Redirect to='error/404' />
          </Switch>
      }
    </Suspense>
  )
}
